import React from "react";
import Button from "src/components/Button";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import useLayout from "src/hooks/useLayout";

interface SubscribeCardProps extends Translation {}

const SubscribeCard = ({ t }: SubscribeCardProps) => {
	const { layout } = useLayout();
	if (layout.navbar.variant !== "default") {
		return <></>;
	}
	return (
		<div className="rounded-md p-6 m-4 bg-dark-accent text-white w-full max-w-[240px]">
			<strong className="flex mb-1">{t("title")}</strong>
			<p
				dangerouslySetInnerHTML={{
					__html: t("description"),
				}}
			/>
			<Button className="mt-4" to="/subscription" type="primary">
				{t("button")}
			</Button>
		</div>
	);
};

SubscribeCard.locale = {
	nl: {
		title: "Upgrade je abonnement",
		description:
			"Besteed taken uit aan meer dan <strong class='text-primary'>{{global.students}} professionals</strong>, en get shit done!",
		button: "Bekijk abonnementen",
	},
	en: {
		title: "Upgrade your payment",
		description:
			"Outsource tasks to more than <strong class='text-primary'>{{global.students}} professionals</strong>, and get shit done!",
		button: "View subscriptions",
	},
};

export default withTranslation(SubscribeCard);
